/**
 * Base error class that all application errors should extend from.
 * Provides consistent error handling across the monorepo.
 */
export class BaseError extends Error {
    cause;
    constructor(message, cause) {
        super(message);
        this.cause = cause;
        // Ensure prototype chain is properly set up for instanceof checks
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
//# sourceMappingURL=BaseError.js.map